import {SelectProvider} from '../../context'
import {SelectLayout} from '../select_layout'

export const NonFloatingSelect = ({sharedProps, ...providerProps}) => {
	return (
		<SelectProvider {...providerProps}>
			<SelectLayout {...sharedProps} />
		</SelectProvider>
	)
}
